module.exports = __webpack_public_path__ + "img/rightArrow.b145e1f1.png";